export async function affExternalShipmentsGetBarcodeImageUseCase(shipment_id, externalShipmentRepository) {

    const result = await externalShipmentRepository.aff_get_barcode_image(shipment_id);

    return result.data;
}